import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import { type Taxonomy, taxonomyQueryStaleTime } from '../types'

export const useTaxonomyList = (): UseQueryResult<
  { items: Taxonomy[] },
  Error
> =>
  useQuery({
    queryKey: ['taxonomyList'],
    queryFn: () =>
      fetchApiWithToken<{ items: Taxonomy[] }>({
        method: 'get',
        url: '/v1/taxonomies'
      }),
    staleTime: taxonomyQueryStaleTime
  })
